import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_052.jpg';
page.paint = [
  {
    id: 'page026_game2',
    icon: 'ikona_cw2',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Uporządkuj rysunek i go pokoloruj.  ',
      audio: 'files/page026/z26c2.mp3',
      item: {
        path: 'informatyka/files/page026/z.26cw.2.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 200,
    },
  },
];
page.word = [
  {
    id: 'page026_game3',
    icon: 'ikona_cw3',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    wordObj: {
      text: 'Uzupełnij zdania. Kliknij w ikonę programu Word.',
      audio: 'files/page026/z26c3.mp3',
      item: {
        path: 'informatyka/files/page026/26_ćw_3_word.docx',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 400,
    },
  },
];
page.images = [
  {
    imageId: 'page052_zoom0',
    rectangle: {
      x: 134 + 160,
      y: 1910,
      width: 1634 - 160,
      height: 542,
    },
    imageSrc: 'images/page052/052 3.jpg',
  },
  {
    imageId: 'page052_zoom1',
    rectangle: {
      x: 140,
      y: 1522,
      width: 1640,
      height: 172,
    },
    imageSrc: 'images/page052/052 2.jpg',
  },
  {
    imageId: 'page052_zoom2',
    rectangle: {
      x: 138,
      y: 1126,
      width: 1638,
      height: 174,
    },
    imageSrc: 'images/page052/052 1.jpg',
  },
];
page.games = [
  {
    id: 'page026_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  // {
  //   id: 'page010_game2',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 200,
  //   },
  // },
  // {
  //   id: 'page019_game3',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 400,
  //   },
  // },
  {
    id: 'page026_game4',
    tooltip: '',
    icon: 'ikona_cw4',
    pos: {
      x: LEFT,
      y: 600,
    },
  },
  // {
  //   id: 'page010_game5',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 800,
  //   },
  // },
];
export default page;
